import { useQuery } from '@tanstack/react-query';
import type { UserFacingMetricsDto } from '@signalvote/shared';
import { authService } from '../../services/authService';
import { apiJson } from './apiFetch';
import { queryKeys } from '../../lib/queryKeys';
import { useCampaignStore } from '../../stores';

export type { UserFacingMetricsDto };

export function useFinanceMetrics() {
  const { selectedCampaign } = useCampaignStore();

  return useQuery({
    queryKey: queryKeys.finance.metrics(),
    queryFn: () =>
      apiJson<UserFacingMetricsDto>('/api/finance/metrics', {
        error: 'Failed to fetch finance metrics',
      }),
    enabled: authService.isAuthenticated() && !!selectedCampaign,
    staleTime: 30_000,
  });
}
